var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 295.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_flat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.5,248.9V396.1L528,469.7l127.5-73.6V248.9L528,175.3Zm62-35.9V432m131-.5-36-239M629.7,234,593.5,431.5",
    transform: "translate(-400 -174.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFlat);
export default __webpack_public_path__ + "static/media/logo_flat.884325fa649757d801203162c0158645.svg";
export { ForwardRef as ReactComponent };